import { createRouteRequest, RouteResponse as Route } from '@busie/api'
import { useAuthTokenWithAudience } from '@busie/core'
import { PathfinderMap } from '@busie/ui-kit'
import React from 'react'
import { DetailsModal, Sidebar } from '~/components'
import { getLatLongFromLocation, getMarkersFromRoute } from '~/helpers'
import { Marker } from '~/models'
import { PathfinderTrip } from '~/models/PathfinderTrip'

export function Pathfinder() {
  const [isLoadingRoute, setIsLoadingRoute] = React.useState(false)
  const [errorMessage, setErrorMessage] = React.useState('')
  const [route, setRoute] = React.useState<Route | null>(null)
  const [markers, setMarkers] = React.useState<Marker[]>([])
  const [isDetailsOpen, setIsDetailsOpen] = React.useState(false)
  const pathfinderAuthToken = useAuthTokenWithAudience('pathfinder')
  const isValidRouteAndMarkers = route && markers.length > 0

  const handleLocationsChange = (pathfinderTrip: PathfinderTrip) => {
    if (pathfinderAuthToken) {
      setIsLoadingRoute(true)
      createRouteRequest(pathfinderAuthToken, {
        vehicleType: 'MOTOR_COACH',
        routeType: 'ONE_WAY',
        start: getLatLongFromLocation(pathfinderTrip.start),
        end: getLatLongFromLocation(pathfinderTrip.end),
        waypoints: pathfinderTrip.stops.map(getLatLongFromLocation),
      })
        .then((newRoute: Route) => {
          setMarkers(getMarkersFromRoute(newRoute))
          setRoute(newRoute)
          setErrorMessage('')
        })
        .catch(() => {
          setErrorMessage('Could not find a route for the specified trip')
          setRoute(null)
        })
        .finally(() => setIsLoadingRoute(false))
    }
  }

  return (
    <>
      <PathfinderMap markers={markers} isFullPage />
      <Sidebar
        onLocationsChange={handleLocationsChange}
        onShowMoreClick={() => isValidRouteAndMarkers && setIsDetailsOpen(true)}
        route={route}
        isLoading={isLoadingRoute}
        errorMessage={errorMessage}
      />
      {isValidRouteAndMarkers && (
        <DetailsModal
          isOpen={isDetailsOpen}
          onClose={() => setIsDetailsOpen(false)}
          route={route}
          markers={markers}
        />
      )}
    </>
  )
}

export default Pathfinder
